import { Component, OnInit ,Input ,HostListener ,Output ,EventEmitter, ChangeDetectorRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Category, CategoryItem, mainRestaurantItem} from 'src/app/models/category';
import { ChangeFood} from 'src/app/models/restaurant'
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { DataService } from 'src/app/services/data.service';


@Component({
  selector: 'app-restaurant-category',
  templateUrl: './restaurant-category.component.html',
  styleUrls: ['./restaurant-category.component.css']
})
export class RestaurantCategoryComponent implements OnInit {
  @Input()items: CategoryItem[];
  @Output()changByFood: EventEmitter<number> = new EventEmitter<number>();
  @Output()changeShowPrice: EventEmitter<number> = new EventEmitter<number>();
  buffer: CategoryItem[] = [];
  loading: boolean;
 restaurantsItem:mainRestaurantItem[]=[];
  restaurantsItemAll:CategoryItem[]=[];
  changeFood:ChangeFood[];
  // id:number=-1;
  text:string;
  categoryName="";
  num=0;
  page:number=1;
  sum = 100;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = "";
  modalOpen = false;
  categoryId:number;
  random:number;
   listId:number;
     private isDestroyed = false;
      showProgress=false;
  // @HostListener('window:popstate', ['$event'])
  // onPopState(event) {
  //   this.backPress();
  // }

  backPress()
{
  this.bussinssService.restaurantCategoryList=null;
} 

  onScrollDown() {
    this.appendItems();
    this.direction = "down";
  }

  onUp() {
    this.sum += 20;
    this.prependItems();
    this.direction = "up";
  }

  prependItems() {
    this.addItems();
  }

  appendItems() {
    this.addItems();
  }

    addItems() {
    if(location.pathname!="/mainHome")
    {
   
    if (this.restaurantsItem.length < this.page * 12) 
      {
        return;
      } 
    this.page =this.page+1;
    if(this.listId>-1 && this.categoryId > -1)
    {
   
    this.getNewMainList(this.listId,this.categoryId,this.page);
  }
  else
  {
    this.bussinssService.getMenuBySearch(this.text,this.page).subscribe((res:any[])=>{
      for(let i=0;i<res.length;i++)
      {
        console.log(this.restaurantsItem)
      this.restaurantsItem.push(res[i]);
      }
    });
  }
  }
}

  constructor(private cd: ChangeDetectorRef,private router: Router,private proxy:AppProxy, private route: ActivatedRoute,private dataService:DataService, private bussinssService:BussinssService) { }


  ngOnInit(): void {
   
    localStorage.back='false';
    localStorage.Category="2";
    window.scroll(0,0);
    this.dataService.byFood.next(false);
    this.changByFood.emit();
    this.dataService.show.next(false);
    this.changeShowPrice.emit();
    sessionStorage.CATEGORY_FILTER=0;
   
    this.text = this.dataService.search.getValue() || "";
    this.dataService.search.subscribe(data=>{
      this.text=data;
      this.page=1;

    if(this.text!="")
    {
      this.showProgress=true;
      this.bussinssService.getMenuBySearch(this.text,this.page).subscribe((res:any[])=>{
       
        this.bussinssService.setGlobalSearch(this.text);
        this.showProgress=false;
      this.restaurantsItem=res
       this.categoryName=this.text;
       this.dataService.search.next("");
  

  return
      });
    
    }
  })


if(this.text=="")
 {
   this.random = Math.floor((Math.random() * 20) + 1);
  this.text = this.dataService.search.getValue() 
  this.categoryId = this.dataService.categoryId.getValue()
  let listId = this.dataService.listId.getValue() ;

  if(listId != undefined && listId!=null && listId>-1 && listId!='')
  {
    this.listId = listId as number;
  
    this.getNewMainList(this.listId,this.categoryId,this.page);
  }
  else
  {

   this.route.params.subscribe(params => {
    console.log(params) //log the entire params object
    let urlId=params['id'];
    sessionStorage.Category=urlId;
    this.showProgress=true;
  this.bussinssService.getCategoryIDByEnName(urlId).subscribe((res:any)=>{
    if(res!=null)
    {
    this.listId=Number(res.ListID);
    this.categoryId=Number(res.CategoryID);
  this.getNewMainList(this.listId,this.categoryId,this.page);
      
  }
  else

  {
   this.page = 1
    this.text = urlId
         this.showProgress=true;
    this.bussinssService.getMenuBySearch(this.text,this.page).subscribe((res:any[])=>{
      this.showProgress=false;
      this.restaurantsItem=res;
      if(this.restaurantsItem!=null && this.restaurantsItem.length>0)
      {
      this.bussinssService.setGlobalSearch(this.text);
      if(this.bussinssService.categoryName!=null)
      this.categoryName = urlId
    }

    });
 

  }

  
});
  if(localStorage.TEXT_SEARCH!=null)
  this.text=localStorage.TEXT_SEARCH;

});
 }


  } 
}


  scrollToTop(): void {
    setTimeout(() => window.scroll(0, 0), 0);
  }

  onClickCategory(id:number){
   }

     getNewMainList(id: number, categoryId: number, page: number) {
    this.showProgress = true;
    if (!this.isDestroyed) this.cd.detectChanges();
    setTimeout(() => {
      const sub = this.bussinssService.getNewMainList(id, categoryId, page, localStorage.LAT, localStorage.LONG, this.random)
        .subscribe((res: any[]) => {
          if (this.isDestroyed) return; 
          this.showProgress = false;
          if (page == 1) {
            this.restaurantsItem = [...res];
          } else {
            this.restaurantsItem = [...this.restaurantsItem, ...res];
          }
          this.bussinssService.mainRestaurantItemList = this.restaurantsItem;
          if (this.restaurantsItem && this.restaurantsItem.length > 0) {
            this.categoryName = this.restaurantsItem[0].Category;
            this.dataService.categoryId.next(-1);
            this.dataService.listId.next(-1);
          } else {
            this.proxy.showError("לא נמצאו עסקים\n בקטגוריה זו", "");
          }
          if (!this.isDestroyed) this.cd.detectChanges();
        });
      // this.routeSub = sub;
    }, 300);
  }
}
